<template>
    <div
        v-if="!element.isNotSupport"
        class="action-machine d-flex flex-row no-select"
        :class="{
            'action-machine--demo': element.isDemo,
            'action-machine--disabled': element.isDemoMachineDisabled,
        }"
    >
        <!-- Is creating... -->
        <div
            v-if="element.isCreating"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end creating mr-3"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                <span>{{ $t('machineAction.creating') }}</span>
                <span v-if="element.cloneProgress && element.cloneProgress > 0">
                    {{ element.cloneProgress }}%
                </span>
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="true"
                color="light-blue"
                height="10"
                :value="0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                {{ $t('machineAction.creatingNote') }}
            </div>
        </div>

        <!-- Is restarting... -->
        <div
            v-if="element.status === $machineStatus.RESTARTING"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end creating mr-3"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                {{ $t('machineAction.restarting') }}
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="true"
                color="light-blue"
                height="10"
                :value="0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                {{ $t('machineAction.processTime5to10') }}
            </div>
        </div>

        <!-- Is reset... -->
        <div
            v-if="element.status === $machineStatus.RESET"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end creating mr-3"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                {{ $t('machineAction.resetting') }}
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="true"
                color="light-blue"
                height="10"
                :value="0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85"
            >
                {{ $t('machineAction.processTime5to10') }}
            </div>
        </div>

        <!-- Is starting... -->
        <div
            v-if="element.isStarting"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end starting mr-3"
        >
            <div style="color: black; font-weight: 500" class="font-size-75">
                <span> {{ element.bootStepText }}... </span>
                <span v-if="element.bootStep === 2" style="color: #757575"
                    >( {{ element.loadingProgress }}% )</span
                >
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="element.bootStep === 2 ? false : true"
                color="light-blue"
                height="10"
                :value="element.bootStep === 2 ? element.loadingProgress : 0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                {{ $t(bootStepDescription[element.bootStep]) }}
            </div>
        </div>

        <!-- Is saving... -->
        <div
            v-if="element.isSaving"
            disabled="true"
            class="d-flex flex-column align-items-center waiting-system"
        >
            <IconSaving />
            <span
                style="color: #fb8c00; font-weight: 500"
                class="font-size-75 mt-2"
            >
                <span>{{ $t('machineAction.saving') }}</span>
                <span v-if="element.loadingProgress > 0">
                    {{ element.loadingProgress }}%
                </span>
            </span>
        </div>

        <!-- Processing... -->
        <div
            v-if=" (element.status === $machineStatus.PROCESSING && !(element.isSnsCreating || element.isSnsRestoring)) "
            disabled="true"
            class="d-flex flex-column align-items-center waiting-system"
        >
            <IconProcessing />
            <span
                style="color: #fb8c00; font-weight: 500"
                class="font-size-75 mt-2"
                >{{ $t('machineAction.processing') }}</span
            >
        </div>

        <!-- Fixed rental renewal -->
        <div
            v-if="element.showRenewalFixedRental"
            @click="action($action.OPEN_POPUP_FIXED_RENTAL_RENEWAL_MACHINE)"
            class="d-flex flex-column align-items-center shutdown-for-clone"
        >
            <IconExtend />
            <span class="font-size-75 mt-2">{{ $t('machineAction.renewal') }}</span>
        </div>

        <!-- Boot machine -->
        <div
            v-if="
                element.canBooting 
                && !(element.isSnsCreating || element.isSnsRestoring)
                && !element.isDemoMachineDisabled
            "
            @click="action($action.OPEN_POPUP_BOOT_MACHINE)"
            class="d-flex flex-column align-items-center boot-system"
        >
            <IconBoot />
            <span class="font-size-75 mt-2 text-nowrap">{{ $t('machineAction.bootReady') }}</span>
        </div>

        <!-- Creating or Restoring -->
        <div
            v-if=" ((element.canBooting || element.status === $machineStatus.PROCESSING || element.status === 1) && (element.isSnsCreating || element.isSnsRestoring)) "
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end starting"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                <span>{{
                    element.isSnsCreating
                        ? $t('machineAction.creatingSnapshot')
                        : $t('machineAction.restoringSnapshot')
                }}</span>
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="element.snsProgress > 0 ? false : true"
                color="light-blue"
                height="10"
                :value="element.snsProgress"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                {{ $t('machineAction.snapshotNote') }}
            </div>
        </div>

        <!-- Report Issues -->
        <div
            v-if="(element.canReportIssues && element.status === 2)"
            @click="action($action.OPEN_POPUP_EXTRA_SERVICE_REPORT_ISSUES)"
            style="text-decoration: none"
            class="d-flex flex-column align-items-center report-issues"
        >
            <i class="el-icon-warning-outline" style="font-size: 2.3rem"></i>
            <span class="font-size-75 mt-2 text-nowrap">{{ $t('machineAction.reportIssues') }}</span>
        </div>

        <!-- Timer -->
        <div
            v-if="element.canScheduler"
            @click="action($action.OPEN_POPUP_SCHEDULER_MACHINE)"
            style="text-decoration: none"
            class="d-flex flex-column align-items-center timer"
        >
            <IconTimer />
            <span class="font-size-75 mt-2">{{ $t('machineAction.scheduler') }}</span>
        </div>

        <!-- Shutdown -->
        <div
            v-if="element.canShutdown"
            @click="action($action.OPEN_POPUP_SHUTDOWN_MACHINE)"
            class="d-flex flex-column align-items-center shutdown"
        >
            <IconShutdown />
            <span class="font-size-75 mt-2">{{ $t('bootMachine.shutdown') }}</span>
        </div>

        <!-- Download remote desktop -->
        <div
            v-if="element.canConnect"
            @click="directConnectToVN ? dowloadRdpOnXhr() : action($action.OPEN_POPUP_DOWNLOAD_REMOTE_DESKTOP)"
            style="text-decoration: none"
            :style="{ opacity: isDownloadingRdp ? 0.5 : 1 }"
            target="_blank"
            class="d-flex flex-column align-items-center connection"
        >
            <IconConnect />
            <span class="font-size-75 mt-2">{{ $t('machineAction.connect') }}</span>
        </div>

        <!-- Error -->
        <div
            v-if="
                element.status === 1 &&
                !(element.isSnsCreating || element.isSnsRestoring)
            "
            class="d-flex flex-column align-items-center image-error"
        >
            <IconError />
            <span class="font-size-75 mt-2">{{ $t('machineAction.error') }}</span>
        </div>
    </div>
</template>

<style>
.v-progress-linear__indeterminate {
    height: inherit !important;
}
</style>

<script>
import axios from "axios";
import { HOST_URL, PRE_FIX_ROUTE, RENTAL_ROUTE } from "@/constant/routeApi";
import { BOOT_STEP_DESCRIPTION } from "@/constant/machine";
import { mapState } from "vuex";

import IconExtend from "@/assets/svg/Extend";
import IconError from "@/assets/svg/Error";
import IconBoot from "@/assets/svg/Boot";
import IconShutdown from "@/assets/svg/Shutdown";
import IconSaving from "@/assets/svg/Saving";
import IconConnect from "@/assets/svg/Connect";
import IconProcessing from "@/assets/svg/Processing";
import IconTimer from "@/assets/svg/Timer";
import {  LIST_PACKAGE_REQUIRED_FIXED_RENTAL } from "@/constant/fixedRental";

export default {
    components: {
        IconExtend,
        IconError,
        IconBoot,
        IconShutdown,
        IconSaving,
        IconConnect,
        IconProcessing,
        IconTimer,
    },

    data() {
        return {
            directConnectToVN: process.env.VUE_APP_CODE === 'IRENDER_GPU_VN',
            isDownloadingRdp: false,
            packageRequiredFixedRental: LIST_PACKAGE_REQUIRED_FIXED_RENTAL,
            bootStepDescription: BOOT_STEP_DESCRIPTION,
        };
    },

    props: {
        element: {
            type: Object,
            default() {
                return {};
            },
        },
    },

	computed: {
		...mapState({
			user: (state) => state.auth.user,
		}),
		downloadFileName() {
			return `${this.element.id}_${this.removeVietnameseTones(
				this.element.name
			).replaceAll(" ", "_")}_${this.user.username}.rdp`;
		},
	},

    methods: {
        action(type) {
            this.$emit("processingEvent", {
                event: "action",
                data: {
                    type: type,
                    data: this.element,
                },
            });
        },
		//#region Remove Vietnamese tones
		removeVietnameseTones(str) {
			str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
			str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
			str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
			str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
			str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
			str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
			str = str.replace(/đ/g, "d");
			str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
			str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
			str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
			str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
			str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
			str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
			str = str.replace(/Đ/g, "D");
			// Some system encode vietnamese combining accent as individual utf-8 characters
			// Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
			str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
			str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
			// Remove extra spaces
			// Bỏ các khoảng trắng liền nhau
			str = str.replace(/ + /g, " ");
			str = str.trim();
			// Remove punctuations
			// Bỏ dấu câu, kí tự đặc biệt
			str = str.replace(
				/!|@|%|\^|\*|\(|\)|\+|=|<|>|\?|\/|,|\.|:|;|'|"|&|#|\[|\]|~|\$|_|`|-|{|}|\||\\/g,
				" "
			);
			return str;
		},
		dowloadRdpOnXhr() {
            if(this.isDownloadingRdp) return;
            this.isDownloadingRdp = true;
			axios({
				method: 'GET',
				url: `${HOST_URL.API_URL}${PRE_FIX_ROUTE.RENTAL}${RENTAL_ROUTE.DOWNLOAD_REMOTE_DESKTOP}/${this.element.id}/VIETNAM`,
				withCredentials: true,
				responseType: 'blob',
			})
				.then((response) => {
                    this.isDownloadingRdp = false;
					const href = URL.createObjectURL(response.data);
					const a = document.createElement('a');
					a.style.display = 'none';
					a.href = href;
					a.setAttribute('download', `${this.downloadFileName}`);
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(href);
				})
				.catch((error) => {
                    this.isDownloadingRdp = false;
					console.log(error);
				});
		},
    },
};
</script>